module.exports = __webpack_public_path__ + "static/media/ic_QR_code.5e5e0874.svg";